import { fuzzySearchResults } from './closestMatchOnKeyFuzzySearchHelpers';

function emailClosestMatchOnKeyName<T extends { key: string; value: string }>(
  data: T[]
): string {
  const emailMatchTerm = 'email';

  let emailMatch = data?.find((x) => x.key.toLowerCase() === emailMatchTerm);

  if (!emailMatch) {
    emailMatch = fuzzySearchResults(emailMatchTerm, data, 50)[0]?.data ?? null;
  }

  if (emailMatch) {
    return emailMatch.value.toLowerCase();
  }

  return 'Unknown Email Address';
}

export default emailClosestMatchOnKeyName;
